<template>
    <div>
        <Row :gutter="16">
            <Col span="18">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row :gutter="16">
                        <Col span="24">
                            <Form :model="formItem" :label-width="80" label-position="right">
                                <FormItem :label="t.role.name" prop="name">
                                    <Input v-model="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.code" prop="code">
                                    <Input v-model="formItem.code" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.sortOrder" prop="sortOrder">
                                    <Input v-model="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.status" prop="status">
                                    <Input v-model="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.createBy" prop="createBy">
                                    <Input v-model="formItem.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.createTime" prop="createTime">
                                    <Input v-model="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.updateBy" prop="remupdateByark">
                                    <Input v-model="formItem.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.updateTime" prop="updateTime">
                                    <Input v-model="formItem.updateTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.role.remark" prop="remark">
                                    <Input v-model="formItem.remark" type="textarea"
                                           :autosize="{minRows: 3,maxRows: 15}" readonly>
                                    </Input>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col span="6">
                <Card>
                    <p slot="title">
                        <Icon type="logo-buffer"/>
                        {{t.menu.menuDistribute}}
                    </p>
                    <P style="padding-left:20px;height: 552px;overflow-x: auto;">
                        <Tree ref="tree" show-checkbox :data="menuList"></Tree>
                    </P>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getTreeMenuList } from '@/api/menu';
import { getRoleInfo } from '@/api/role';

export default {
    name: 'organization_role_detail',

    data() {
        const t = this.$_t();
        return {
            t: t,
            formItem: {
                name: '',
                status: '',
                code: '',
                sortOrder: '',
                menuIdList: [],
                remark: '',
            },
            //所有的后台权限菜单列
            menuList: [],
        };
    },
    methods: {
        //被选中的角色权限匹配映射
        async serSelectedForMenuIdList(nodeElement) {
            for (let i = 0; i < nodeElement.length; i++) {
                //所有节点选中不可
                nodeElement[i].disabled = true;
                this.findChildren(nodeElement[i]);
            }
        },
        //通过寻找子节点后匹配选中的节点
        async findChildren(parentNode) {
            if (parentNode.children != null && parentNode.children.length > 0) {
                this.serSelectedForMenuIdList(parentNode.children);
            } else {
                for (let j = 0; j < this.formItem.menuIdList.length; j++) {
                    if (parentNode.id === this.formItem.menuIdList[j]) {
                        parentNode.checked = true;
                    }
                }
            }
        },
        async init() {
            //得到当前角色详情信息
            const roleInfo = await getRoleInfo(this.$route.params.id);

            if (roleInfo.role != null) {
                this.formItem = roleInfo.role;
                //状态判断
                if (roleInfo.role.status === '0') {
                    this.formItem.status = this.t.role.close;
                } else if (roleInfo.role.status === '1') {
                    this.formItem.status = this.t.role.open;
                }

                //得到后台所有菜单展示
                const menuList = await getTreeMenuList({ division: 2 });
                if (menuList.menus != null && menuList.menus.length > 0) {
                    this.menuList = menuList.menus;
                    //被选中的角色权限匹配映射
                    this.serSelectedForMenuIdList(menuList.menus);
                }
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
